import axios from "axios"

import CisInsightService from "@/services/cis-insight.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default class makeDtSetInsight {
    constructor (category, st_dt, en_dt) {
        this.sel_category = category
        this.st_dt = st_dt
        this.en_dt = en_dt

        this.majorClsList = []
    }

    async initialize() {
        await this.getMajorClsList()
    }

    async getMajorClsList() {
        // 선택한 카테고리의 대분류 정보를 획득한다. (데이터 셋 생성 시 대분류 필터 적용 용도)
        const firstClasses = await CisInsightService.listFirstClass({
            ctgSq: this.sel_category
        }, source);

        if (firstClasses.data.success)
            this.majorClsList = firstClasses.data.data
    }

    async run() {
        const cdj_list = ['카테고리 탐색', '속성 탐색', '구매 및 관리']

        var resDataset = [];

        var cdj_tb_data = null;

        const cdj_tb_resp = await CisInsightService.getInsightDataCDJTableExp({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : [],
            firstClassList : [],
            selMiddle: null, 
        }, source);

        if (cdj_tb_resp && cdj_tb_resp.status === 200) {
            cdj_tb_data = cdj_tb_resp.data.data;

            var chartCat = cdj_tb_data[0].date.split(','); 
            var brandFreqData = [];       

            var gen_search_freq_upper = [];

            var gen_search_freq_upper0 = cdj_tb_data[0].freq.split(',')
            var gen_search_freq_upper1 = cdj_tb_data[1].freq.split(',')
            var gen_search_freq_upper2 = cdj_tb_data[2].freq.split(',')

            for (var idx = 0; idx < chartCat.length; idx++) {
                var val0 = parseFloat(gen_search_freq_upper0[idx]) || 0;
                var val1 = parseFloat(gen_search_freq_upper1[idx]) || 0;
                var val2 = parseFloat(gen_search_freq_upper2[idx]) || 0;

                gen_search_freq_upper.push(val0 + val1 + val2)
            }

            brandFreqData.push({
                cdj: '카테고리 탐색',
                freq: gen_search_freq_upper
            })

            var atr_search_freq_upper = [];

            var atr_search_freq_upper0 = cdj_tb_data[3].freq.split(',')
            var atr_search_freq_upper1 = cdj_tb_data[4].freq.split(',')
            var atr_search_freq_upper2 = cdj_tb_data[5].freq.split(',')
            var atr_search_freq_upper3 = cdj_tb_data[6].freq.split(',')
            var atr_search_freq_upper4 = cdj_tb_data[7].freq.split(',')

            for (var idx = 0; idx < chartCat.length; idx++) {
                var val0 = parseFloat(atr_search_freq_upper0[idx]) || 0;
                var val1 = parseFloat(atr_search_freq_upper1[idx]) || 0;
                var val2 = parseFloat(atr_search_freq_upper2[idx]) || 0;
                var val3 = parseFloat(atr_search_freq_upper3[idx]) || 0;
                var val4 = parseFloat(atr_search_freq_upper4[idx]) || 0;

                atr_search_freq_upper.push(val0 + val1 + val2 + val3 + val4)
            }

            brandFreqData.push({
                cdj: '속성 탐색',
                freq: atr_search_freq_upper
            })

            var buy_manage_freq_upper = [];

            var buy_manage_freq_upper0 = cdj_tb_data[8].freq.split(',')
            var buy_manage_freq_upper1 = cdj_tb_data[9].freq.split(',')

            for (var idx = 0; idx < chartCat.length; idx++) {
                var val0 = parseFloat(buy_manage_freq_upper0[idx]) || 0;
                var val1 = parseFloat(buy_manage_freq_upper1[idx]) || 0;

                buy_manage_freq_upper.push(val0 + val1)
            }

            brandFreqData.push({
                cdj: '구매 및 관리',
                freq: buy_manage_freq_upper
            })

            var tot_search_freq_upper = [];

            for (var idx = 0; idx < chartCat.length; idx++) {
                var val0 = gen_search_freq_upper[idx] || 0;
                var val1 = atr_search_freq_upper[idx] || 0;
                var val2 = buy_manage_freq_upper[idx] || 0;

                tot_search_freq_upper.push(val0 + val1 + val2)
            }

            brandFreqData.push({
                cdj: 'Total',
                freq: tot_search_freq_upper
            })

            resDataset.push({'sheet_type': 0, 'sheet_nm': '소비자 탐색 오버뷰_전체', 'data': brandFreqData, 'cat': chartCat})
        }

        for (const cdj of cdj_list) {
            const overview_resp = await CisInsightService.getInsightDataDonutBarExp({
                startDate : this.st_dt,
                endDate : this.en_dt,
                ctgSq : this.sel_category,
                brandList : [],
                firstClassList : [],       
                cdj : cdj
            }, source);

            if (overview_resp && overview_resp.status === 200) {
                var overview_tb_data = overview_resp.data.data;
               
                var chartCat = null; 
                var brandShareData = [];

                for(const item of overview_tb_data.barData) {
                    if (chartCat == null)
                        chartCat = item.date.split(',');

                    brandShareData.push({
                        keyword: item.brand,
                        freq: item.freq.split(',')
                    });
                }

                if (chartCat != null && brandShareData.length > 0)
                    resDataset.push({'sheet_type': 1, 'sheet_nm': `브랜드 점유율(${cdj})_전체`, 'data': brandShareData, 'cat': chartCat})
            }
        }

        // stacked chart category setting
        var cdjDetails = []

        for(const item of cdj_tb_data)
            cdjDetails.push(item.cdjDetails)

        const stacked_resp = await CisInsightService.getInsightDataStackedExp({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : [],
            firstClassList : [],
            selMiddle: null, 
            cdjDetail1 :  cdjDetails[0],
            cdjDetail2 :  cdjDetails[1],
            cdjDetail3 :  cdjDetails[2],
            cdjDetail4 :  cdjDetails[3],
            cdjDetail5 :  cdjDetails[4],
            cdjDetail6 :  cdjDetails[5],
            cdjDetail7 :  cdjDetails[6],
            cdjDetail8 :  cdjDetails[7],
            cdjDetail9 :  cdjDetails[8],
            cdjDetail10 : cdjDetails[9]
        }, source);

        if (stacked_resp && stacked_resp.status === 200) {
            var stacked_data = stacked_resp.data.data;

            var chartCat = null; 
            var stackChartData = [];

            for(const item of stacked_data) {
                if (chartCat == null)
                    chartCat = item.date.split(','); 

                stackChartData.push({
                    brand: item.brand,
                    cdj: item.cdj,
                    cdj_details: item.cdjDetails,
                    prop: item.prop,
                    freq: item.freq.split(',')
                });
            }

            if (chartCat != null && stackChartData.length > 0)
                resDataset.push({'sheet_type': 2, 'sheet_nm': '소비자 탐색 인사이트_전체', 'data': stackChartData, 'cat': chartCat})
        }

        var brandList = [];

        const br_li_resp = await CisInsightService.listBrand({
            ctgSq: this.sel_category,
            firstClassList : []
        }, source);

        if (br_li_resp.data.success) {
            for(const item of br_li_resp.data.data) {
                if (item.title != 'NONBRANDED')
                    brandList.push(item.title)
            }
        }

        const br_stacked_resp = await CisInsightService.getInsightDataStackedExp({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : brandList,
            firstClassList : [],
            selMiddle: null, 
            cdjDetail1 :  cdjDetails[0],
            cdjDetail2 :  cdjDetails[1],
            cdjDetail3 :  cdjDetails[2],
            cdjDetail4 :  cdjDetails[3],
            cdjDetail5 :  cdjDetails[4],
            cdjDetail6 :  cdjDetails[5],
            cdjDetail7 :  cdjDetails[6],
            cdjDetail8 :  cdjDetails[7],
            cdjDetail9 :  cdjDetails[8],
            cdjDetail10 : cdjDetails[9]
        }, source);

        if (br_stacked_resp && br_stacked_resp.status === 200) {
            var stacked_data = br_stacked_resp.data.data;

            var chartCat = null; 
            var stackChartData = [];

            for(const item of stacked_data) {
                if (chartCat == null)
                    chartCat = item.date.split(','); 

                stackChartData.push({
                    brand: item.brand,
                    cdj: item.cdj,
                    cdj_details: item.cdjDetails,
                    prop: item.prop,
                    freq: item.freq.split(',')
                });
            }

            if (chartCat != null && stackChartData.length > 0)
                resDataset.push({'sheet_type': 2, 'sheet_nm': '소비자 탐색 인사이트(B)_전체', 'data': stackChartData, 'cat': chartCat})
        }

        const nonbr_stacked_resp = await CisInsightService.getInsightDataStackedExp({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : ['NONBRANDED'],
            firstClassList : [],
            selMiddle: null, 
            cdjDetail1 :  cdjDetails[0],
            cdjDetail2 :  cdjDetails[1],
            cdjDetail3 :  cdjDetails[2],
            cdjDetail4 :  cdjDetails[3],
            cdjDetail5 :  cdjDetails[4],
            cdjDetail6 :  cdjDetails[5],
            cdjDetail7 :  cdjDetails[6],
            cdjDetail8 :  cdjDetails[7],
            cdjDetail9 :  cdjDetails[8],
            cdjDetail10 : cdjDetails[9]
        }, source);

        if (nonbr_stacked_resp && nonbr_stacked_resp.status === 200) {
            var stacked_data = nonbr_stacked_resp.data.data;

            var chartCat = null; 
            var stackChartData = [];

            for(const item of stacked_data) {
                if (chartCat == null)
                    chartCat = item.date.split(','); 

                stackChartData.push({
                    brand: item.brand,
                    cdj: item.cdj,
                    cdj_details: item.cdjDetails,
                    prop: item.prop,
                    freq: item.freq.split(',')
                });
            }

            if (chartCat != null && stackChartData.length > 0)
                resDataset.push({'sheet_type': 2, 'sheet_nm': '소비자 탐색 인사이트(NB)_전체', 'data': stackChartData, 'cat': chartCat})
        }

        const up_tb_resp = await CisInsightService.getInsightDataUpperTableDateExp({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : [],
            firstClassList : [],          
            cdj : 'total'
        }, source);

        if (up_tb_resp && up_tb_resp.status === 200) {
            var up_tb_data = up_tb_resp.data.data;
            var chartCat = null;
            var topRankKeywords = [];

            for(const item of up_tb_data) {
                if (chartCat == null)
                    chartCat = item.date.split(','); 

                topRankKeywords.push({
                    keyword: item.keyword,
                    brand: item.brand,
                    prop: item.prop,
                    freq: item.freq.split(',')
                });
            }

            if (chartCat != null && topRankKeywords.length > 0)
                resDataset.push({'sheet_type': 3, 'sheet_nm': '검색량 상위 키워드_전체', 'data': topRankKeywords, 'cat': chartCat})
        }

        const br_up_tb_resp = await CisInsightService.getInsightDataUpperTableDateExp({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : brandList,
            firstClassList : [],          
            cdj : 'total'
        }, source);

        if (br_up_tb_resp && br_up_tb_resp.status === 200) {
            var br_up_tb_data = br_up_tb_resp.data.data;
            var chartCat = null; 
            var topRankKeywords = [];

            for(const item of br_up_tb_data) {
                if (chartCat == null)
                    chartCat = item.date.split(',');

                topRankKeywords.push({
                    keyword: item.keyword,
                    brand: item.brand,
                    prop: item.prop,
                    freq: item.freq.split(',')
                });
            }

            if (chartCat != null && topRankKeywords.length > 0)
                resDataset.push({'sheet_type': 3, 'sheet_nm': '검색량 상위 키워드(B)_전체', 'data': topRankKeywords, 'cat': chartCat})
        }

        const nonbr_up_tb_resp = await CisInsightService.getInsightDataUpperTableDateExp({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            brandList : ['NONBRANDED'],
            firstClassList : [],          
            cdj : 'total'
        }, source);

        if (nonbr_up_tb_resp && nonbr_up_tb_resp.status === 200) {
            var nonbr_up_tb_data = nonbr_up_tb_resp.data.data;
            var chartCat = null; 
            var topRankKeywords = [];

            for(const item of nonbr_up_tb_data) {
                if (chartCat == null)
                    chartCat = item.date.split(','); 

                topRankKeywords.push({
                    keyword: item.keyword,
                    brand: item.brand,
                    prop: item.prop,
                    freq: item.freq.split(',')
                });
            }

            if (chartCat != null && topRankKeywords.length > 0)
                resDataset.push({'sheet_type': 3, 'sheet_nm': '검색량 상위 키워드(NB)_전체', 'data': topRankKeywords, 'cat': chartCat})
        }

        if (this.majorClsList.length > 0) {
            for (const major of this.majorClsList) {
                var cdj_tb_data = null;

                const cdj_tb_resp = await CisInsightService.getInsightDataCDJTableExp({
                    startDate : this.st_dt,
                    endDate : this.en_dt,
                    ctgSq : this.sel_category,
                    brandList : [],
                    firstClassList : [major.id],
                    selMiddle: null, 
                }, source);

                if (cdj_tb_resp && cdj_tb_resp.status === 200) {
                    cdj_tb_data = cdj_tb_resp.data.data;

                    var chartCat = cdj_tb_data[0].date.split(','); 
                    var brandFreqData = [];       
                    var gen_search_freq_upper = [];

                    var gen_search_freq_upper0 = cdj_tb_data[0].freq.split(',')
                    var gen_search_freq_upper1 = cdj_tb_data[1].freq.split(',')
                    var gen_search_freq_upper2 = cdj_tb_data[2].freq.split(',')

                    for (var idx = 0; idx < chartCat.length; idx++) {
                        var val0 = parseFloat(gen_search_freq_upper0[idx]) || 0;
                        var val1 = parseFloat(gen_search_freq_upper1[idx]) || 0;
                        var val2 = parseFloat(gen_search_freq_upper2[idx]) || 0;

                        gen_search_freq_upper.push(val0 + val1 + val2)
                    }

                    brandFreqData.push({
                        cdj: '카테고리 탐색',
                        freq: gen_search_freq_upper
                    })

                    var atr_search_freq_upper = [];

                    var atr_search_freq_upper0 = cdj_tb_data[3].freq.split(',')
                    var atr_search_freq_upper1 = cdj_tb_data[4].freq.split(',')
                    var atr_search_freq_upper2 = cdj_tb_data[5].freq.split(',')
                    var atr_search_freq_upper3 = cdj_tb_data[6].freq.split(',')
                    var atr_search_freq_upper4 = cdj_tb_data[7].freq.split(',')

                    for (var idx = 0; idx < chartCat.length; idx++) {
                        var val0 = parseFloat(atr_search_freq_upper0[idx]) || 0;
                        var val1 = parseFloat(atr_search_freq_upper1[idx]) || 0;
                        var val2 = parseFloat(atr_search_freq_upper2[idx]) || 0;
                        var val3 = parseFloat(atr_search_freq_upper3[idx]) || 0;
                        var val4 = parseFloat(atr_search_freq_upper4[idx]) || 0;

                        atr_search_freq_upper.push(val0 + val1 + val2 + val3 + val4)
                    }

                    brandFreqData.push({
                        cdj: '속성 탐색',
                        freq: atr_search_freq_upper
                    })

                    var buy_manage_freq_upper = [];

                    var buy_manage_freq_upper0 = cdj_tb_data[8].freq.split(',')
                    var buy_manage_freq_upper1 = cdj_tb_data[9].freq.split(',')

                    for (var idx = 0; idx < chartCat.length; idx++) {
                        var val0 = parseFloat(buy_manage_freq_upper0[idx]) || 0;
                        var val1 = parseFloat(buy_manage_freq_upper1[idx]) || 0;

                        buy_manage_freq_upper.push(val0 + val1)
                    }

                    brandFreqData.push({
                        cdj: '구매 및 관리',
                        freq: buy_manage_freq_upper
                    })

                    var tot_search_freq_upper = [];

                    for (var idx = 0; idx < chartCat.length; idx++) {
                        var val0 = gen_search_freq_upper[idx] || 0;
                        var val1 = atr_search_freq_upper[idx] || 0;
                        var val2 = buy_manage_freq_upper[idx] || 0;

                        tot_search_freq_upper.push(val0 + val1 + val2)
                    }

                    brandFreqData.push({
                        cdj: 'Total',
                        freq: tot_search_freq_upper
                    })

                    resDataset.push({'sheet_type': 0, 'sheet_nm': `소비자 탐색 오버뷰_${major.title}`, 'data': brandFreqData, 'cat': chartCat})
                }

                for (const cdj of cdj_list) {
                    const overview_resp = await CisInsightService.getInsightDataDonutBarExp({
                        startDate : this.st_dt,
                        endDate : this.en_dt,
                        ctgSq : this.sel_category,
                        brandList : [],
                        firstClassList : [major.id],       
                        cdj : cdj
                    }, source);

                    if (overview_resp && overview_resp.status === 200) {
                        var overview_tb_data = overview_resp.data.data;
                        var chartCat = null; 
                        var brandShareData = [];

                        for(const item of overview_tb_data.barData) {
                            if (chartCat == null)
                                chartCat = item.date.split(',');

                            brandShareData.push({
                                keyword: item.brand,
                                freq: item.freq.split(',')
                            });
                        }

                        if (chartCat != null && brandShareData.length > 0)
                            resDataset.push({'sheet_type': 1, 'sheet_nm': `브랜드 점유율(${cdj})_${major.title}`, 'data': brandShareData, 'cat': chartCat})
                    }
                }

                // stacked chart category setting
                var cdjDetails = []

                for(const item of cdj_tb_data)
                    cdjDetails.push(item.cdjDetails)

                const stacked_resp = await CisInsightService.getInsightDataStackedExp({
                    startDate : this.st_dt,
                    endDate : this.en_dt,
                    ctgSq : this.sel_category,
                    brandList : [],
                    firstClassList : [major.id],
                    selMiddle: null, 
                    cdjDetail1 :  cdjDetails[0],
                    cdjDetail2 :  cdjDetails[1],
                    cdjDetail3 :  cdjDetails[2],
                    cdjDetail4 :  cdjDetails[3],
                    cdjDetail5 :  cdjDetails[4],
                    cdjDetail6 :  cdjDetails[5],
                    cdjDetail7 :  cdjDetails[6],
                    cdjDetail8 :  cdjDetails[7],
                    cdjDetail9 :  cdjDetails[8],
                    cdjDetail10 : cdjDetails[9]
                }, source);

                if (stacked_resp && stacked_resp.status === 200) {
                    var stacked_data = stacked_resp.data.data;

                    var chartCat = null; 
                    var stackChartData = [];

                    for(const item of stacked_data) {
                        if (chartCat == null)
                            chartCat = item.date.split(','); 

                        stackChartData.push({
                            brand: item.brand,
                            cdj: item.cdj,
                            cdj_details: item.cdjDetails,
                            prop: item.prop,
                            freq: item.freq.split(',')
                        });
                    }

                    if (chartCat != null && stackChartData.length > 0)
                        resDataset.push({'sheet_type': 2, 'sheet_nm': `소비자 탐색 인사이트_${major.title}`, 'data': stackChartData, 'cat': chartCat})
                }

                const nonbr_up_tb_resp = await CisInsightService.getInsightDataUpperTableDateExp({
                    startDate : this.st_dt,
                    endDate : this.en_dt,
                    ctgSq : this.sel_category,
                    brandList : [],
                    firstClassList : [major.id],          
                    cdj : 'total'
                }, source);

                if (up_tb_resp && up_tb_resp.status === 200) {
                    var nonbr_up_tb_data = nonbr_up_tb_resp.data.data;
                    var chartCat = null; 
                    var topRankKeywords = [];

                    for(const item of nonbr_up_tb_data) {
                        if (chartCat == null)
                            chartCat = item.date.split(','); 

                        topRankKeywords.push({
                            keyword: item.keyword,
                            brand: item.brand,
                            prop: item.prop,
                            freq: item.freq.split(',')
                        });
                    }

                    if (chartCat != null && topRankKeywords.length > 0)
                        resDataset.push({'sheet_type': 3, 'sheet_nm': `검색량 상위 키워드_${major.title}`, 'data': topRankKeywords, 'cat': chartCat})
                }
            }
        }

        return resDataset
    }
}